<div class="status-form">
    <div class="form-content">
        <form [formGroup]="statusForm" *ngIf="statusForm && !isLoading">
            <div class="section-title status-name-title">{{ 'request_v2.status_form.status_name' | translate }}</div>

            <div class="name-form" formGroupName="name">
                <app-form-input-v2 label="{{ 'request_v2.status_form.english_name' | translate }}" placeholder="" formControlName="en">
                    <app-form-error *ngIf="statusForm.get('name').get('en').touched && statusForm.get('name').get('en').hasError('required')">
                        {{ 'request_v2.status_form.name_required' | translate }}
                    </app-form-error>
                </app-form-input-v2>

                <app-form-input-v2 label="{{ 'request_v2.status_form.french_name' | translate }}" placeholder="" formControlName="fr">
                    <app-form-error *ngIf="statusForm.get('name').get('fr').touched && statusForm.get('name').get('fr').hasError('required')">
                        {{ 'request_v2.status_form.name_required' | translate }}
                    </app-form-error>
                </app-form-input-v2>
            </div>

            <div class="section-title status-type-title">{{ 'request_v2.status_form.status_type' | translate }}</div>

            <div class="status-type-form">
                <app-form-select-v2
                    placeholder="{{ 'request_v2.status_form.select_status_type' | translate }}"
                    formControlName="statusType"
                    [options]="statusTypeOptions"
                    [invalid]="statusForm.get('statusType').touched && statusForm.get('statusType').invalid"
                >
                    <app-form-error *ngIf="statusForm.get('statusType').touched && statusForm.get('statusType').hasError('required')">
                        {{ 'request_v2.status_form.type_required' | translate }}
                    </app-form-error>
                </app-form-select-v2>
            </div>
        </form>

        <div *ngIf="isLoading" class="loading-indicator">
            <p>{{ 'request_v2.status_form.loading' | translate }}</p>
        </div>

        <div *ngIf="!statusForm && !isLoading" class="loading-indicator">
            <p>{{ 'request_v2.status_form.loading' | translate }}</p>
        </div>
    </div>
</div>
